import { CSSProperties } from 'react';
import { grey } from 'globals/colors';

export const getIconButtonBoxStyle = (): CSSProperties => ({
  width: 24,
  height: 24,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const getNoTextWrapStyle = (): CSSProperties => ({
  whiteSpace: 'nowrap',
});

export const getNoPaddingStyle = (): CSSProperties => ({
  padding: 0,
});

export const getIconStyle = (): CSSProperties => ({
  color: grey.V3,
});
